/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-11-19 15:46:53
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-02-12 21:16:19
 * @FilePath: \baishu_react_ui\src\components\BsyFormDataManager\BsyFormWidgetManager.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import get from "lodash/get";
import map from "lodash/map";

import ShowRulesProcessor from "../../utils/ShowRulesProcessor";
import { BsyUtils } from "../../utils/Utils";
import BsyAddress from "../BsyAddress";
import BsyCheckGroup from "../BsyCheckGroup";
import BsyComboBox from "../BsyComboBox";
import BsyComboCheckBox from "../BsyComboCheckBox";
import BsyDateTime from "../BsyDateTime";
import BsyDept from "../BsyDept";
import BsyDeptGroup from "../BsyDeptGroup";
import BsyFileUpload from "../BsyFileUpload";
import BsyImageUpload from "../BsyImageUpload";
import BsyLocation from "../BsyLocation";
import BsyNumber from "../BsyNumber";
import BsyRadioGroup from "../BsyRadioGroup";
import BsySignature from "../BsySignature";
import BsySubform from "../BsySubform";
import BsyTextArea from "../BsyTextArea";
import BsyTextEditor from "../BsyTextEditor";
import BsyUser from "../BsyUser";
import BsyUserGroup from "../BsyUserGroup";
import BsyButton from "../BsyButton";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyLinkData from "../BsyLinkData";
import isEqual from "lodash/isEqual";
import _ from "lodash";
import rowExecuteRely_3_0, {
  memoryWidget,
} from "../../utils/rowExecuteRely_3_0";

//管理单行的数据
export default class BsyFormWidgetManager {
  constructor(props) {
    this.props = props;

    this.labelMap = {};
    this.fieldData = { ...props.data };
    this.initFieldData = JSON.parse(JSON.stringify(props.data)); //用于处理，是否要调用更新接口
    this.flow = props.flow;

    this.dataTable = props.dataTable;
    this.multiTabs = props.multiTabs;
    this.submitUrl = props.submitUrl;
    this.formItems = [...props.formItems];
    this.ignoreAuth = props.ignoreAuth;
    this.validators = props.validators;
    this.fieldShowRules = props.fieldShowRules || [];
    this.subformFieldShowRules = props.subformFieldShowRules || [];
    this.noRely = props.noRely;
    this.submitData = props.submitData || {};
    this.dataUrl = props.dataUrl;
    this.widgetId = props.widgetId;
    this.extDashData = props.extDashData;
    this.popupFormPath = props.popupFormPath || [];
    this.appId = props.appId;
    this.formId = props.formId;
    this.entryId = props.entryId;
    this.refAppId = props.refAppId;
    this.authGroupId = props.authGroupId;
    this.isChangeSubform = false;
    let _this = this;
    this.tabMap = {};
    this.showRules = {};
    this.subVisbleMaps = {};
    this.subColumnVisibleMaps = {};
    this.errorStatusMap = {}; //管理状态的一个错误状态
    this.optAuth = props.optAuth;
    this.options = {
      validators: props.validators,
      fieldShowRules: props.fieldShowRules,
      subformFieldShowRules: props.subformFieldShowRules,
      formId: props.formId,
      appId: props.appId,
      entryId: props.entryId,
      dataId: this.fieldData._id,
      resultWidgets: {},
      ignoreAuth: props.ignoreAuth,
      multiTabs: this.multiTabs,
      items: this.formItems,
    };
    this.updateDelay = 2000;
    this.setRowElement();
    //先构建对象
    this.rowRely = new rowExecuteRely_3_0({
      appId: this.appId,
      formId: this.formId || this.entryId,
      items: this.formItems,
      form: this,
      dataTable: props.dataTable,
    });

    BsyUtils.forEach(this.formItems, (index, item) => {
      if (item.hasOwnProperty("tab")) {
        this.tabMap[item.tab] = this.tabMap[item.tab] || [];
        this.tabMap[item.tab].push(item.widget.widgetName);
      }

      if (!BsyUtils.isObjectEmpty(this.optAuth)) {
        if (this.optAuth.hasOwnProperty(item.widget.widgetName)) {
          item.widget.visible = this.optAuth[item.widget.widgetName].visible;
          item.widget.enabled = this.optAuth[item.widget.widgetName].enabled;
          item.widget.is_file_down =
            this.optAuth[item.widget.widgetName].is_file_down;
          item.widget.online_edit =
            this.optAuth[item.widget.widgetName].online_edit;
          item.widget.online_edit_record =
            this.optAuth[item.widget.widgetName].online_edit_record;
        } else {
          item.widget.visible = false;
          item.widget.enabled = false;
        }
      }

      let config = {
        ...item.widget,
        tab: item.tab,
        source: "BsyFormWidgetManager",
        designAppId: props.appId,
        designEntryId: props.formId || props.entryId,
        onAfterWidgetCreate: function (a) {
          return _this.rowRely.registerField(a);
        },
        onDeleteRow: function (a) {
          return _this.rowRely.removeField(a);
        },
        onDeleteAll: function (a) {
          return _this.rowRely.removeSubformAllField(a);
        },
      };

      let d = _this.newWdiget(
        item.widget.type,
        config,
        this.fieldData[item.widget.widgetName]
      );

      if (d) {
        _this.options.resultWidgets[item.widget.widgetName] = d;
        _this.labelMap[item.widget.widgetName] = item.label;
        if (item.widget.type === "subform") {
          BsyUtils.forEach(d.options.items, (index, item1) => {
            _this.labelMap[
              [item.widget.widgetName, item1.widget.widgetName].join(".")
            ] = [item.label, item1.label].join(".");
          });
        }
        //20231114
        var def = new memoryWidget({
          ...item,
          field: d,
          formMode: "edit",
          value: _this.fieldData[item.widget.widgetName],
        });
        d._bindField(_this.rowRely.registerField(def));
        def.setVisible(d.getVisible());

        // _this._addLinkQuery(def);
        // def.setValue(_this.fieldData[item.widget.widgetName]);
      }
    });

    let d = [...this.formItems];

    BsyUtils.forEach(this.multiTabs, (tabindex, tabdata) => {
      d.push({
        label: React.language("multi.tab.name") + "." + tabdata.title,
        widget: {
          widgetName: tabdata.name,
          type: "tabs",
        },
      });
    });

    this.showRulesProcessor = new ShowRulesProcessor({
      fieldShowRules: this.fieldShowRules,
      fields: d, //this.formItems
    });
    this.subShowRulesProcessorMap = {};
    this.widgetsMap = {};
    this.visibleWidgetsMap = {};
    this.orgvisibleWidgetsMap = {};
    this.authVisibleMap = {};
    this.systemWidgetConfig = {
      creator: {
        name: "creator",
        type: "user",
        text: React.language("field.creator"),
      },
      createTime: {
        name: "createTime",
        type: "datetime",
        format: "yyyy-MM-dd HH:mm:ss",
        text: React.language("field.createTime"),
      },
      updateTime: {
        name: "updateTime",
        type: "datetime",
        format: "yyyy-MM-dd HH:mm:ss",
        text: React.language("field.updateTime"),
      },
      _id: {
        name: "_id",
        type: "text",
        text: React.language("data.id"),
      },
    };
  }

  newWdiget = (type, widget, value) => {
    let that = this;
    switch (type) {
      case "sn":
      case "text": {
        return new BsyTextEditor({
          ...widget,
          value: value,
        });
      }
      case "textarea": {
        return new BsyTextArea({
          ...widget,
          value: value,
        });
      }
      case "number": {
        return new BsyNumber({
          ...widget,
          value: value,
        });
      }
      case "linkdata": {
        return new BsyLinkData({
          ...widget,
          value: value,
        });
      }
      case "datetime": {
        return new BsyDateTime({
          ...widget,
          value: value,
        });
      }
      case "radiogroup": {
        return new BsyRadioGroup({
          ...widget,
          value: value,
        });
      }
      case "checkboxgroup": {
        return new BsyCheckGroup({
          ...widget,
          value: value,
        });
      }
      case "combocheck":
        return new BsyComboCheckBox({
          ...widget,
          value: value,
          onBeforeAsync: () => {
            let filter = that.rowRely._iterAddFilter(widget, null, null);
            return filter;
          },
        });
      case "combo":
        return new BsyComboBox({
          ...widget,
          value: value,
          onBeforeAsync: () => {
            let filter = that.rowRely._iterAddFilter(widget, null, null);
            return filter;
          },
        });
      case "address":
        return new BsyAddress({
          ...widget,
          value: value,
        });
      case "location":
        return new BsyLocation({
          ...widget,
          value: value,
        });

      case "button": {
        return new BsyButton({
          ...widget,
        });
      }
      case "user":
        return new BsyUser({
          ...widget,
          value: value,
        });
      case "usergroup":
        return new BsyUserGroup({
          ...widget,
          value: value,
        });
      case "dept":
        return new BsyDept({
          ...widget,
          value: value,
        });
      case "deptgroup":
        return new BsyDeptGroup({
          ...widget,
          value: value,
        });
      case "upload": {
        return new BsyFileUpload({
          ...widget,
          value: value,
        });
      }
      case "image": {
        return new BsyImageUpload({
          ...widget,
          value: value,
        });
      }
      case "signature": {
        return new BsySignature({
          ...widget,
          value: value,
        });
      }
      case "subform": {
        return new BsySubform({
          ...widget,
          showMode: "dataManager", //form 走普通方式， dataManager 走通用模式
          value: value,
        });
      }
      default: {
      }
    }
  };

  onResetRel = (t) => {
    if (this.pupupDashContext && this.pupupDashContext.setRel)
      this.pupupDashContext.setRel(t);
  };

  onResetFilter = (t) => {
    this.pupupDashContext.ResetFilter();
  };

  getPupupDashContext = (content) => {
    this.pupupDashContext = content;
  };

  _getSubformIds = (name) => {
    let f = this.getWidgetByName(name);
    if (f) {
      let g = f.getObjectValue();
      let ids = [];
      BsyUtils.forEach(g, function (id, v) {
        ids.push(v.id);
      });
      return ids;
    } else {
      return [];
    }
  };

  _writeBackFrom = (value, arg) => {
    var _this = this;
    BsyUtils.forEach(arg, function (argindex, item) {
      var widget = _this.getWidgetByName(item.field);
      if (!widget)
        //字段被删除不回写
        return;
      if (item.mode === "custom") {
        // widget.setValue(item.value);
        _this.setFieldValue(item.field, item.value, -1, true);
      } else if (item.mode === "currentUser") {
        // widget.setValue(window.FX.STATIC?.user?._id);
        _this.setFieldValue(item.field, window.FX.STATIC?.user?._id, -1, true);
      } else {
        if (item.depend && item.depend.field) {
          if (value[item.depend.field]) {
            _this.setFieldValue(item.field, value[item.depend.field], -1, true);
            // widget.setValue(value[item.depend.field].data)
          } else {
            _this.setFieldValue(item.field, null, -1, true);
          }
        }
      }
    });
  };

  buttonEvent = (widgetName, subrowIndex, event, callback) => {
    let field = this.getWidgetByName(widgetName, subrowIndex);
    if (field) {
      if (
        field.options.funMode === "module" ||
        field.options.funMode === "all" ||
        field.options.funMode === "event" ||
        field.options.funMode === "datahelp" ||
        field.options.funMode === "formEvent" ||
        (field.options.extendSet &&
          (field.options.extendSet.funMode === "module" ||
            field.options.extendSet.funMode === "event" ||
            field.options.extendSet.funMode === "datahelp" ||
            field.options.extendSet.funMode === "formEvent" ||
            field.options.extendSet.funMode === "all"))
      ) {
        if (this.ignoreAuth && this.noRely) {
          return;
        }
        this.rowRely.buttonEvent(field.field, event, callback);
        this.updateData();
      } else {
        this.rowRely.buttonEvent(field.field, event, callback);
      }
    }
    return;
  };

  getCurrentFieldElement = (widget, subRowIndex, field, subRid) => {
    if (!this.dataTable) return null;
    let selector = " ." + widget.replace(".", "-") + " .content-edit";

    if (subRid) {
      selector =
        " ." + widget.replace(".", "-") + ".F" + subRid + " .content-edit";
    } else {
      if (
        subRowIndex > -1 ||
        (field.field.subform && field.field.rowIdx > -1)
      ) {
        selector =
          " ." +
          widget.replace(".", "-") +
          "-subrow-" +
          subRowIndex +
          " .content-edit";
      }
    }

    if (field) {
      switch (field.getWidgetType()) {
        case "location": {
          selector = " ." + widget.replace(".", "-");
          break;
        }
        default: {
        }
      }
    }

    let widgetElement = null;
    if (BsyUtils.isSubformWidget(widget)) {
      if (subRowIndex === undefined) {
        widgetElement = [];
        for (let i = 0; i < this.element.current.length; i++) {
          widgetElement.push(this.element.current[i].querySelector(selector));
        }
      } else {
        //扩展体系会出现子表单数据行数改变的情况 需要前置判断
        // if (this.element.current[subRowIndex]) {
        //     widgetElement = this.element.current[subRowIndex].querySelector(selector);
        // } else {
        //dataid="51c8d48f93e6ed3ec9b35c75"  _widget_1698978307356-_widget_1698978307396-subrow-46
        let widgetStr =
          ".art-table-row.row" + this.fieldData._id + " " + selector;
        console.log(widgetStr);
        widgetElement = this.dataTable.element.current.querySelector(widgetStr);
        if (!widgetElement) {
          widgetStr =
            ".art-table-row.row" +
            this.fieldData._id +
            " ." +
            widget.replace(".", "-");
          widgetElement =
            this.dataTable.element.current.querySelector(widgetStr);
        }
        // }
      }
    } else {
      widgetElement = this.element.current[0].querySelector(selector);
    }
    return widgetElement;
  };

  rebuild = (widget, subRowIndex) => {
    // let field = null;
    // if (BsyUtils.isSubformWidget(widget)) {
    //     let names = widget.split('.');
    //     let subform = names[0];
    //     let widgetName = names[1];
    //     // if (!this.options.resultWidgets[subform].subformComponents[subRowIndex || 0][widgetName]) {
    //         console.log("未处理的控件" + widget)
    //         return;
    //     }
    //     // field = this.options.resultWidgets[subform].subformComponents[subRowIndex || 0][widgetName]
    // } else {
    //     if (!this.options.resultWidgets[widget]) {
    //         console.log("未处理的控件" + widget)
    //         return;
    //     }
    //     // field = this.options.resultWidgets[widget]
    // }
  };

  getOptions = (widget, subRowIndex) => {
    let field = null;
    if (BsyUtils.isSubformWidget(widget)) {
      let names = widget.split(".");
      let subform = names[0];
      let widgetName = names[1];
      field =
        this.options.resultWidgets[subform].subformComponents[subRowIndex || 0][
          widgetName
        ];
    } else {
      field = this.options.resultWidgets[widget];
    }
    return field ? field.options : null;
  };

  setLableConfig = (widget, opt, subRowIndex) => {
    if (this.props.form) {
      this.props.form.setLableConfig(widget, opt, subRowIndex);
    }
  };

  setOptions = (widget, opt, subRowIndex) => {
    let field = null;
    if (BsyUtils.isSubformWidget(widget)) {
      let names = widget.split(".");
      let subform = names[0];
      let widgetName = names[1];
      field =
        this.options.resultWidgets[subform].subformComponents[subRowIndex || 0][
          widgetName
        ];
      if (field)
        this.options.resultWidgets[subform].subformComponents[subRowIndex || 0][
          widgetName
        ].options = { ...field.options, ...opt };
    } else {
      field = this.options.resultWidgets[widget];
      if (field) {
        this.options.resultWidgets[widget].options = {
          ...field.options,
          ...opt,
        };
        if (this.props.form) {
          let formfield = this.props.form.getWidgetByName(widget);
          if (formfield) {
            formfield.options = { ...formfield.options, ...opt };
            formfield.rebuild();
          }
        }
      }
    }
  };

  setValue = (el) => {
    if (el.subform) {
      this.rowRely.fieldMap[el.subform.widgetName].setItemValue(el);
      this.options.resultWidgets[el.subform.widgetName].setItemValue(el);
    }
  };

  //20231114
  fireWidgetRelyEvent = function (a, b) {
    this.rowRely.fireEvent(a, () => {
      this.rowRely.fireWidgetRelyEvent(a, b);
    });
  };
  fireSubformRowRely = function (e, t, n) {
    this.rowRely.fireSubformRowRely(e, t, n);
  };

  setSystemFieldValue = (widget, data) => {
    let widgetElement = this.element.current[0].querySelector("." + widget);
    let wd = this.systemWidgetConfig[widget];
    if (widgetElement) {
      this.dataTable.renderEditAfterCell(widgetElement, wd, data);
    }
  };

  setFieldValueMap = (widget, valueMap, subRowIndex) => {
    let field = null;
    if (BsyUtils.isSubformWidget(widget)) {
      let names = widget.split(".");
      let subform = names[0];
      let widgetName = names[1];

      if (
        !this.options.resultWidgets[subform].subformComponents[
          subRowIndex || 0
        ][widgetName]
      ) {
        console.log("未处理的控件" + widget);
        return;
      }
      field =
        this.options.resultWidgets[subform].subformComponents[subRowIndex || 0][
          widgetName
        ];
    } else {
      if (!this.options.resultWidgets[widget]) {
        console.log("未处理的 控件" + widget);
        return;
      }

      field = this.options.resultWidgets[widget];
    }
    field.valueMap = valueMap;
  };

  setFieldData = (widget, data, subRowIndex, subRid) => {
    let widgetElement = null;
    let field = null;
    if (BsyUtils.isSubformWidget(widget)) {
      let names = widget.split(".");
      let subform = names[0];
      let widgetName = names[1];

      console.log(`setFieldData ${subform} ${subRowIndex} ${widgetName}`);
      // console.log(this.options.resultWidgets[subform].subformComponents)

      let subidx = subRowIndex || 0;
      if (
        this.options.resultWidgets[subform].subformComponents.length <= subidx
      ) {
        console.log("未处理的控件" + widget);
        return;
      }

      if (
        !this.options.resultWidgets[subform].subformComponents[subidx][
          widgetName
        ]
      ) {
        console.log("未处理的控件" + widget);
        return;
      }
      if (!this.fieldData[subform]) {
        this.fieldData[subform] = [{}];
      }
      if (this.fieldData[subform].length === 0) {
        this.fieldData[subform] = [{}];
      }
      this.fieldData[subform][subRowIndex || 0][widgetName] = data;
      field =
        this.options.resultWidgets[subform].subformComponents[subRowIndex || 0][
          widgetName
        ];
      this.options.resultWidgets[subform].dataSource[subRowIndex || 0][
        widgetName
      ] = data;
      // field.field.setValue(data, null, !0);
      if (this.dataTable) {
        widgetElement = this.getCurrentFieldElement(
          widget,
          subRowIndex,
          field,
          subRid
        ); //this.element.current[subRowIndex].querySelector(selector);
        if (!widgetElement) {
          if (this.element.current[subRowIndex]) {
            widgetElement = this.element.current[subRowIndex].querySelector(
              "." + subform + "-" + widgetName
            );
          }
        }
        if (widgetElement) {
          //先赋值给界面
          this.dataTable.renderEditAfterCell(
            widgetElement,
            { ...field.options, name: widgetName, subform: subform },
            data,
            this.fieldData,
            subRowIndex
          );
        }
      }

      // this.isChangeSubform = true;
    } else {
      if (!this.options.resultWidgets[widget]) {
        console.log("未处理的 控件" + widget);
        return;
      }

      field = this.options.resultWidgets[widget];
      if (field.options.type === "subform") {
        //刷新整个子表单，不立即更新到界面，等数据update后 再刷新
        this.isChangeSubform = true;
        this.fieldData[widget] = data;
      } else {
        console.log(field.getWidgetType());
        if (this.dataTable) {
          widgetElement = this.getCurrentFieldElement(widget, -1, field);
          if (!widgetElement) {
            widgetElement = this.element.current[0].querySelector("." + widget);
          }
          if (widgetElement) {
            //先赋值给界面
            this.dataTable.renderEditAfterCell(
              widgetElement,
              { ...field.options, name: widget },
              data,
              this.fieldData
            );
          }
        }
      }
    }

    // console.log(field.getWidgetName(), data);
    field.setValue(data);
    this.getNameMap(field, data);
    //防止数据格式异常
    if (field.getWidgetType() === "subform") {
      this.fieldData[widget] = field.getObjectValue();
    } else {
      this.fieldData[widget] = field.getValue();
    }

    //widgetElement 不为null  表示组件为可见状态，需要验证规则，需要为不可见的时候，则不需要验证规则
    if (widgetElement && !field.checkValidate()) {
      if (
        this.showRules &&
        this.showRules.hasOwnProperty(widget) &&
        this.showRules[widget] === false
      ) {
      } else {
        //处理错误信息
        if (this.dataTable)
          this.dataTable.renderErrorTip(
            widgetElement,
            field.getInvalidateTypeText()
          );
      }
    }
  };

  setFieldValueRead = (widget, data, subRowIndex, run) => {
    this.setFieldData(widget, data, subRowIndex);
    if (this.props.form) {
      this.props.form.setFieldValue(widget, data, subRowIndex);
    }
  };

  setFieldValue = (widget, data, subRowIndex, run, subRid) => {
    this.setFieldData(widget, data, subRowIndex, subRid);
    if (this.props.form) {
      this.props.form.setFieldValue(widget, data, subRowIndex, subRid);
    }
    // this.updateData();
    //执行公式
    if (run) {
      if (this.ignoreAuth && this.noRely) {
        this.goRowExecuteRely(
          widget,
          subRowIndex == null ? -1 : subRowIndex,
          false
        );
        return;
      }

      this.goRowExecuteRely(widget, subRowIndex == null ? -1 : subRowIndex);
    }
  };

  getFieldValue = (widget, subRowIndex) => {
    if (BsyUtils.isSubformWidget(widget)) {
      let names = widget.split(".");
      let subform = names[0];
      let widgetName = names[1];

      if (
        !this.options.resultWidgets[subform].subformComponents[
          subRowIndex || 0
        ][widgetName]
      ) {
        console.log("未处理的控件" + widget);
        return null;
      }
      let field =
        this.options.resultWidgets[subform].subformComponents[subRowIndex || 0][
          widgetName
        ];
      if (field) {
        return field.getValue();
      }
    } else {
      let field = this.options.resultWidgets[widget];
      if (field) {
        if (field.getWidgetType() === "subform") {
          return field.getObjectValue();
        } else {
          return field.getValue();
        }
      }
    }

    return null;
  };

  getObjectValue = () => {
    let b = this,
      c = {},
      d = b.options.resultWidgets;

    for (let e in d) {
      let f = d[e];
      if (f && BsyUtils.isValueWidget(f.getWidgetType())) {
        let g = f.getValue();

        if (f.options.type === "subform") {
          g = f.getOrgObjectValue();

          let gd = [];
          for (let i = 0; i < g.length; i++) {
            let el = g[i];
            let obj = {};
            BsyUtils.forEach(el, function (a1, b1) {
              if (b1) {
                if (b1.hasOwnProperty("data")) {
                  obj[a1] = b1.data;
                } else {
                  obj[a1] = b1;
                }
              }
            });
            gd.push(obj);
          }
          g = gd;
        }
        c[e] = g;
      }
    }
    return c;
  };

  goRowExecuteRely = (widgetName, subRowIndex, isRun) => {
    let widget = this.getWidgetByName(widgetName, subRowIndex);

    if (widget) {
      widget.setMemValue(null, isRun);
    }
  };

  // _structureWidgets = (objvalue) => {
  //     objvalue = objvalue || this.getObjectValue();
  //     this.rowRely._structureWidgets(this.formItems, objvalue, this.nameMap || {})
  // }

  getNameMap = (field, data) => {
    let that = this;
    this.nameMap = this.nameMap || {};
    if (!field) {
      return;
    }
    if (!data) {
      return;
    }

    switch (field.type) {
      case "dept":
      case "user": {
        if (data) {
          if (data.hasOwnProperty("id") || data.hasOwnProperty("_id")) {
            let id = data.id || data._id;
            this.nameMap[id] = data.name || data.nickname;
          }
        }
        break;
      }

      case "usergroup":
      case "deptgroup": {
        if (data) {
          BsyUtils.forEach(data, (d1, d2) => {
            if (d2) {
              if (d2.hasOwnProperty("id") || d2.hasOwnProperty("_id")) {
                let id = d2.id || d2._id;
                that.nameMap[id] = d2.name || d2.nickname;
              }
            }
          });
        }

        break;
      }
      case "subform": {
        BsyUtils.forEach(data, (rowid, row) => {
          BsyUtils.forEach(field.options.items, (index, item) => {
            let val = row[item.widget.widgetName];
            switch (item.widget.type) {
              case "dept":
              case "user": {
                if (val) {
                  if (val.hasOwnProperty("id") || val.hasOwnProperty("_id")) {
                    let id = val.id || val._id;
                    that.nameMap[id] = val.name || val.nickname;
                  }
                }

                break;
              }

              case "usergroup":
              case "deptgroup": {
                if (val) {
                  BsyUtils.forEach(val, (d1, d2) => {
                    if (d2) {
                      if (d2.hasOwnProperty("id") || d2.hasOwnProperty("_id")) {
                        let id = d2.id || d2._id;
                        that.nameMap[id] = d2.name || d2.nickname;
                      }
                    }
                  });
                }

                break;
              }
              default:
            }
          });
        });
        break;
      }
      default: {
      }
    }

    return this.nameMap;
  };

  setRowElement = () => {
    if (!this.dataTable) {
      return;
    }

    let selector = ".art-table-body  .row-id-" + this.fieldData._id;
    let rowElement = this.dataTable.element.current.querySelectorAll(selector); //需要考虑子表单的情况
    this.element = {
      current: rowElement,
    };
  };

  getWidgetName = (field) => {
    return field.options.widgetName;
  };

  getWidgetByName = (field, subformIndex) => {
    if (BsyUtils.isEmpty(field) || !this.options.resultWidgets) return null;
    let d;
    if (BsyUtils._isSubformWidget(field)) {
      let sarr = field.split(".");
      let e = this.options.resultWidgets[sarr[0]];
      if (BsyUtils.isObjectEmpty(subformIndex) || subformIndex == -1) {
        let arr = [];
        for (let i = 0; i < e.subformComponents.length; i++) {
          arr.push(e.subformComponents[i][sarr[1]]);
        }
        return arr;
      }
      if (!e.subformComponents || !e.subformComponents[subformIndex]) {
        return null;
      }

      d = e.subformComponents[subformIndex][sarr[1]];
      // e && (d = e.getWidgetByName(a.split(".")[1], b))
    } else d = this.options.resultWidgets[field];
    return d;
  };

  getValue = () => {
    let a = this.options,
      b = this,
      c = {},
      d = a.resultWidgets;
    this.checkRepeat = [];
    for (let e in d) {
      let f = d[e];
      if (f && BsyUtils.isValueWidget(f.getWidgetType())) {
        let g = f.getValue();
        if (f.options.type === "number" || f.options.type === "subform") {
          g = f.getText();
          if (f.options.type === "number" && g === "") {
            g = null;
          }
        } else if (f.options.type === "combocheck") {
          if (BsyUtils.isString(g)) {
            if (g.length === 0) {
              g = null;
            } else {
              g = [g];
            }
          }
        }
        if (f.options.noRepeat && !BsyUtils.isEmpty(g)) {
          let h = {};
          h[f.options.widgetName] = g;
          b.checkRepeat.push(h);
        }
        if (f.options.type === "subform" && !BsyUtils.isEmpty(g)) {
          let items = f.options.items,
            noRepeatArr = {},
            noRepeatValue = {};
          if (!BsyUtils.isEmpty(items)) {
            BsyUtils.forEach(items, function (key, value) {
              if (value.widget.noRepeat) {
                noRepeatArr[
                  [f.options.widgetName, value.widget.widgetName].join(".")
                ] = 1;
              }
            });
          }

          BsyUtils.forEach(g, function (key, value) {
            !BsyUtils.isEmpty(value) &&
              BsyUtils.forEach(value, function (skey, svalue) {
                let subname = [f.options.widgetName, skey].join(".");
                if (svalue.data !== undefined && noRepeatArr[subname]) {
                  noRepeatValue[subname]
                    ? noRepeatValue[subname].push(svalue.data)
                    : (noRepeatValue[subname] = [svalue.data]);
                }
              });
          });
          !BsyUtils.isObjectEmpty(noRepeatValue) &&
            b.checkRepeat.push(noRepeatValue);
        }

        let isVisible = f.isVisible();
        if (b.showRules && b.showRules.hasOwnProperty(e)) {
          isVisible = b.showRules[e];
        }

        if ( this.dataTable) {
          isVisible = this.dataTable.getWidgetVisible(e);
        }
        if (b.ignoreAuth) {
          isVisible = true;
        }

        c[e] = {
          data: g,
          visible: isVisible,
        };
      }
    }

    return c;
  };

  doSubmit = (success, error, extData) => {
    if (this.submitIng) {
      return;
    }

    console.log("doSubmit");
    let submitData = {
      dataId: this.props.mode === "new" ? undefined : this.fieldData["_id"],
      ...this.submitData,
      values: this.getValue(),
      hasResult: !0,
      flowAction: this.props.flowAction,
      flowType: this.props.flowType,
      candidateId: this.props.candidateId,
      designDataId: this.props.mode === "new" ? this.props.designDataId : null,
      islinkquery: this.props.islinkquery,
      islinkdata: this.props.islinkdata,
      widgetName: this.props.designWidgetName,
      subformName: this.props.designSubformName,
      appId: this.appId,
      entryId: this.entryId,
      formId: this.formId || this.entryId,
      // refAppId: this.refAppId,
      checkRepeat: this.checkRepeat,
      // hasResult: !0,
      authGroupId: this.popupFormPath.length > 0 ? null : this.authGroupId, //this.authGroupId,
      popupFormPath: this.extDashData ? null : this.popupFormPath,
      extDashData: this.extDashData,
    };
    if (!BsyUtils.isObjectEmpty(extData)) {
      submitData = { ...submitData, ...extData };
    }

    this.submitIng = true;

    React.axios(this.submitUrl, submitData)
      .then((res) => {
        this.submitIng = false;
        BsyUtils.showAjaxTip(
          res.data,
          () => {
            success && success(res);
          },
          () => {
            error && error(res);
          }
        );
        console.log(res);
      })
      .catch((res) => {
        this.submitIng = false;
        console.log(res);
        error && error(res);
      });
  };

  //数据已更新后，需要清理自己
  clearSelf = () => {
    this.dataTable.dataManager.remove(this.fieldData._id);
  };

  //将数据转换为数据表可以使用的，否则无法正确显示
  convertDatatable(data) {
    let newData = { ...data };
    let that = this;
    BsyUtils.forEach(newData, function (key, value) {
      let field = that.options.resultWidgets[key];
      if (field) {
        switch (field.options.type) {
          case "dept":
          case "user": {
            if (value) {
              if (value.hasOwnProperty("_id") || value.hasOwnProperty("id")) {
                newData[key] = value;
              } else {
                if (that.nameMap[value]) {
                  newData[key] = {
                    id: value,
                    nickname: that.nameMap[value],
                  };
                } else {
                  newData[key] = {
                    id: value,
                    nickname: value,
                  };
                }
              }
            } else {
              newData[key] = null;
            }

            break;
          }

          case "usergroup":
          case "deptgroup": {
            let val = [];
            BsyUtils.forEach(value, (d1, d2) => {
              if (d2) {
                if (d2.hasOwnProperty("_id") || d2.hasOwnProperty("id")) {
                  val.push(d2);
                } else {
                  if (that.nameMap[d2]) {
                    val.push({
                      id: d2,
                      nickname: that.nameMap[d2],
                    });
                  } else {
                    val.push({
                      id: d2,
                      nickname: d2,
                    });
                  }
                }
              }
            });
            newData[key] = val;
            break;
          }
          case "subform": {
            let subvalue = newData[key];

            BsyUtils.forEach(subvalue, (rowid, row) => {
              BsyUtils.forEach(field.options.items, (index, item) => {
                let value = row[item.widget.widgetName];
                switch (item.widget.type) {
                  case "dept":
                  case "user": {
                    if (value) {
                      if (
                        value.hasOwnProperty("_id") ||
                        value.hasOwnProperty("id")
                      ) {
                        subvalue[rowid][item.widget.widgetName] = value;
                      } else {
                        if (that.nameMap[value]) {
                          subvalue[rowid][item.widget.widgetName] = {
                            id: value,
                            nickname: that.nameMap[value],
                          };
                        } else {
                          subvalue[rowid][item.widget.widgetName] = {
                            id: value,
                            nickname: value,
                          };
                        }
                      }
                    }

                    break;
                  }

                  case "usergroup":
                  case "deptgroup": {
                    let val = [];
                    BsyUtils.forEach(value, (d1, d2) => {
                      if (d2) {
                        if (
                          d2.hasOwnProperty("_id") ||
                          d2.hasOwnProperty("id")
                        ) {
                          val.push(d2);
                        } else {
                          if (that.nameMap[d2]) {
                            val.push({
                              id: d2,
                              nickname: that.nameMap[d2],
                            });
                          } else {
                            val.push({
                              id: d2,
                              nickname: d2,
                            });
                          }
                        }
                      }
                    });
                    subvalue[rowid][item.widget.widgetName] = val;
                    break;
                  }
                  default:
                }
              });
            });
            newData[key] = subvalue;
            break;
          }
          default: {
          }
        }
      }
    });
    return newData;
  }

  diffData = (newData, id) => {
    let _this = this;
    _this.isChangeSubform = false;
    let difflist = [];

    const rowData = this.dataTable.resultData.data.filter((it) => {
      return it._id === id;
    });
    const header = this.dataTable.resultData.header;

    BsyUtils.forEach(header, (index, item) => {
      const { name: key, tag } = item;
      const data = rowData[0][tag || key];
      let field = _this.options.resultWidgets[key];
      if (field) {
        if (field.options.type !== "subform") {
          if (data !== newData[key]) {
            difflist.push({
              name: key,
              value: newData[key],
            });
          }
        } else {
          //if (newData[key] && data) {
          if ((data || []).length === (newData[key] || []).length) {
            let oldData = data || [];
            BsyUtils.forEach(oldData, (subformkey, subformvalue) => {
              BsyUtils.forEach(subformvalue, (key1, value1) => {
                if (key1 === "id") return;

                if (
                  BsyUtils.isObjectEmpty(value1) ||
                  BsyUtils.isObjectEmpty(newData[key][subformkey][key1])
                ) {
                  if (
                    BsyUtils.isObjectEmpty(value1) ===
                    BsyUtils.isObjectEmpty(newData[key][subformkey][key1])
                  ) {
                    return;
                  } else {
                    difflist.push({
                      name: [key, key1].join("."),
                      subRowIndex: subformkey,
                      value: newData[key][subformkey][key1],
                    });
                    return;
                    // issame = false;
                    // return false;
                  }
                }
                if (Array.isArray(value1)) {
                  value1 = value1.sort((s, j) => {
                    return s > j;
                  });
                }
                if (Array.isArray(newData[key][subformkey][key1])) {
                  newData[key][subformkey][key1] = newData[key][subformkey][
                    key1
                  ].sort((s, j) => {
                    return s > j;
                  });
                }
                if (!isEqual(value1, newData[key][subformkey][key1])) {
                  difflist.push({
                    name: [key, key1].join("."),
                    subRowIndex: subformkey,
                    value: newData[key][subformkey][key1],
                  });
                  return;
                }
              });
            });
          } else {
            _this.isChangeSubform = true;
          }
          //}
        }
      } else {
        if (["createTime", "updateTime"].indexOf(key) > -1) {
          if (data !== newData[key]) {
            // difflist.push(key);
            difflist.push({
              name: key,
              value: newData[key],
            });
          }
        }
      }
    });
    return difflist;
  };
  //对比数据是否有被修改
  valueCompare = () => {
    let newValue = this.getValue();
    let issame = true;
    let that = this;
    const header = this.dataTable.resultData.header;
    BsyUtils.forEach(header, (key, item) => {
      const { name, type,tag } = item;
      const namekey = name || tag;
      var value = newValue[namekey];
      if (namekey.indexOf("_widget") === -1) {
        return;
      }
      if (["separator", "button", "dataload", "linkquery"].includes(type)) {
        return;
      }

      if (that.options.resultWidgets[name].options.type === "subform") {
        if (value.data) {
          if (!that.initFieldData[name]) {
            issame = false;
            return false;
          }

          if (value.data.length !== that.initFieldData[name].length) {
            issame = false;
            return false;
          }

          BsyUtils.forEach(value.data, (subformkey, subformvalue) => {
            //subformvalue

            let fit = that.initFieldData[name].find((it) => {
              return it.id === subformvalue.id.data;
            });

            BsyUtils.forEach(item.items, (key1, subitem) => {
              const { name: subname } = subitem;
              var value1 = subformvalue[subname];
              if (
                BsyUtils.isObjectEmpty(value1.data) ||
                BsyUtils.isObjectEmpty(fit[key1])
              ) {
                if (
                  BsyUtils.isObjectEmpty(value1.data) ===
                  BsyUtils.isObjectEmpty(fit[key1])
                ) {
                  return true;
                } else {
                  issame = false;
                  return false;
                }
              }
              if (Array.isArray(value1.data)) {
                value1.data = value1.data.sort((s, j) => {
                  return s > j;
                });
              }
              if (Array.isArray(fit[key1])) {
                fit[key1] = fit[key1].sort((s, j) => {
                  return s > j;
                });
              }
              if (!isEqual(value1.data, fit[key1])) {
                issame = false;
                return false;
              }
            });
            if (!issame) {
              return false;
            }
          });
        }
      } else {
        if (
          BsyUtils.isObjectEmpty(value.data) ||
          BsyUtils.isObjectEmpty(that.initFieldData[key])
        ) {
          if (
            BsyUtils.isObjectEmpty(value.data) ===
            BsyUtils.isObjectEmpty(that.initFieldData[key])
          ) {
            return true;
          } else {
            issame = false;
            return false;
          }
        }
        if (Array.isArray(value.data)) {
          value.data = value.data.sort((s, j) => {
            return s > j;
          });
        }
        if (Array.isArray(that.initFieldData[key])) {
          that.initFieldData[key] = that.initFieldData[key].sort((s, j) => {
            return s > j;
          });
        }

        if (!isEqual(value.data, that.initFieldData[key])) {
          issame = false;
          return false;
        }
      }
    });

    return issame;
  };

  readData = () => {
    let _this = this;
    _this.isChangeSubform = false;
    React.axios(_this.dataUrl, {
      appId: _this.appId,
      formId: _this.formId,
      entryId: _this.entryId,
      dataId: _this.fieldData._id,
      refAppId: _this.refAppId,
      iseditable: false,
      authGroupId: _this.authGroupId,
      popupFormPath: _this.popupFormPath,
      widgetId: this.widgetId,
      ..._this.dataTable.getReadDataExt(),
    })
      .then((res) => {
        // if (BsyUtils.isObjectEmpty(res.data.data)) {
        //   // 为空，清空内存中的数据
        //   _this.dataTable.mergeDataToTable(null, _this.fieldData._id);
        //   _this.dataTable.mergeSubformDataToTable();
        // } else {
        let datalist = _this.diffData(res.data.data, _this.fieldData._id);
        _this.dataTable.mergeDataToTable(res.data.data, _this.fieldData._id); //每次都合并最新数据，更新根据实际情况

        if (_this.isChangeSubform) {
          //子表单
          _this.dataTable.mergeSubformDataToTable();
          _this.isChangeSubform = false;
        } else {
          BsyUtils.forEach(datalist, (a1, b1) => {
            if (["createTime", "updateTime", "creator"].indexOf(b1.name) > -1) {
              _this.setSystemFieldValue(b1.name, b1.value);
            } else {
              _this.setFieldValueRead(b1.name, b1.value, b1.subRowIndex);
            }
          });
          _this.dataTable.renderRowFieldErrorTip(_this.fieldData._id);
        }
        // }
        _this.isChangeSubform = false;
        _this.clearSelf();
      })
      .catch((res) => {
        console.error(res);
        if (_this.isChangeSubform) {
          _this.dataTable.mergeSubformDataToTable(_this.fieldData);
          _this.isChangeSubform = false;
        }
      });
  };

  ddm = () => {
    let _this = this;
    let valueCompare = _this.valueCompare();

    if (valueCompare) {
      //虽然数据一样，但是还是需要调用一次read，拉取最新数据，兼容后端触发修改逻辑
      _this.dataTable.renderRowLinkingTip(_this.fieldData._id, "");
      _this.readData();
      return;
    }

    _this.doSubmit(
      () => {
        _this.dataTable.renderRowLinkingTip(_this.fieldData._id, "");
        _this.readData();
      },
      (res) => {
        _this.isChangeSubform = false;
        if (res.data) {
          switch (res.data.code) {
            case 4002: {
              _this.dataTable.renderRowErrorTip(
                _this.fieldData._id,
                res.data.msg
              );

              BsyUtils.forEach(res.data.meta.repeatFields, (key, value) => {
                if (BsyUtils.isSubformWidget(value)) {
                  let widgetElements = _this.getCurrentFieldElement(value);
                  // 先按表单编辑显示， 此处逻辑需要改动，正常应该只标记重复的值
                  let subs = value.split(".");
                  let val = _this.options.resultWidgets[subs[0]].getItemValue(
                    subs[1]
                  );
                  for (let i = 0; i < widgetElements.length; i++) {
                    let widgetElement = widgetElements[i];

                    if (
                      widgetElement &&
                      res.data.meta.repeatFieldsData[value] &&
                      res.data.meta.repeatFieldsData[value].indexOf(val[i]) > -1
                    ) {
                      _this.dataTable.renderErrorTip(
                        widgetElement,
                        React.language("repeat.tip")
                      );
                    }
                  }
                } else {
                  let field = _this.getWidgetByName(value);
                  let widgetElement = _this.getCurrentFieldElement(
                    value,
                    -1,
                    field
                  );
                  if (widgetElement) {
                    _this.dataTable.renderErrorTip(
                      widgetElement,
                      React.language("repeat.tip")
                    );
                  }
                }
              });
              break;
            }

            default: {
              _this.dataTable.renderRowErrorTip(
                _this.fieldData._id,
                res.data.msg
              );
              break;
            }
          }
        }
      }
    );
  };

  setRowErrorTip = (a) => {
    let _this = this;
    if (!a.result) {
      //数据验证的时候，提示的错误信息
      _this.errMsg = a.errMsg
        ? a.errMsg
        : React.language("form.submit.invalid");
      if (_this.dataTable) {
        _this.dataTable.renderRowFieldErrorTip(
          _this.fieldData._id,
          _this.errMsg
        );
        _this.dataTable.renderRowLinkingTip(_this.fieldData._id, "");
      } else {
        tipAlert({
          type: "warning",
          msg: _this.errMsg,
        });
      }
    }
    return a.result;
  };

  formLoadLayer = () => {
    // let that = this;
    this.clearAllInfo();
  };

  formLoadLayerRemove = () => {
    // this.layerRef && this.layerRef.close()
    // this.layerRef = null;
  };

  getCacheValue = () => {
    const { resultWidgets } = this.options;
    let that = this;
    this.cacheValue = {};
    BsyUtils.forEach(resultWidgets, (a1, b2) => {
      if (b2.getWidgetType() === "subform")
        that.cacheValue[a1] = b2.getObjectValue();
      else that.cacheValue[a1] = b2.getValue();
    });
    return this.cacheValue;
  };

  clearAllInfo = () => {
    let _this = this;
    //先清所 原始的错误信息
    _this.dataTable.renderRowErrorTip(_this.fieldData._id, "");
    _this.dataTable.renderRowLinkingTip(_this.fieldData._id, "1");
  };

  updateData = () => {
    let _this = this;
    if (!_this.dataTable) {
      return;
    }

    if (_this.time) {
      clearTimeout(_this.time);
      _this.time = null;
    }

    if (!this.noRely) {
      //验证公式联动是否执行完成
      if (!this.rowRely.ajaxLoading && this.rowRely.checkRelyAsyncState()) {
        console.log("this.rowRely.checkRelyAsyncState true");

        let a = _this.rowRely.doVerify();
        //联动完成后再校验数据
        if (!_this.setRowErrorTip(a)) {
          return false;
        }

        _this.time = setTimeout(() => {
          _this.time = null;
          _this.clearAllInfo();
          _this.ddm();
        }, _this.updateDelay);
      } else {
        console.log("this.rowRely.checkRelyAsyncState false");
        let dem = () => {
          //判断是否有数据联动的请求在没有执行完成
          if (
            !_this.rowRely.ajaxLoading &&
            !_this.rowRely.rely.isAsyncCalculating()
          ) {
            _this.dataTable.renderRowErrorTip(_this.fieldData._id, "");
            if (_this.time) {
              clearTimeout(_this.time);
              _this.time = null;
            }
            _this.time = setTimeout(() => {
              _this.time = null;
              _this.ddm();
            }, _this.updateDelay);
          } else {
            let delay = setInterval(() => {
              if (_this.rowRely.ajaxLoading) {
                return;
              }

              if (_this.rowRely.checkRelyAsyncState()) {
                console.log("this.rowRely.checkRelyAsyncState true");
                _this.dataTable.renderRowErrorTip(_this.fieldData._id, "");
                if (_this.time) {
                  clearTimeout(_this.time);
                  _this.time = null;
                }

                let a = _this.rowRely.doVerify();
                //联动完成后再校验数据
                if (!_this.setRowErrorTip(a)) {
                  clearInterval(delay);
                  delay = null;
                  return false;
                }

                _this.time = setTimeout(() => {
                  _this.time = null;
                  _this.clearAllInfo();
                  _this.ddm();
                }, _this.updateDelay);
                clearInterval(delay);
                delay = null;
              } else {
                let errmap = _this.rowRely.rely.getErrorMap();

                if (BsyUtils.isObjectEmpty(errmap)) {
                  // 2025 05 28 快捷编辑数据 提前提交导致异常 待观察
                  // _this.time = setTimeout(() => {
                  //   _this.time = null;
                  //   _this.ddm();
                  // }, _this.updateDelay);
                  // clearInterval(delay);
                  // delay = null;
                } else {
                  BsyUtils.forEach(errmap, (a1, b1) => {
                    let names = a1;
                    let widgetElement = null;
                    if (a1.indexOf(":") > -1) {
                      names = a1.split(":");
                      widgetElement = _this.getCurrentFieldElement(
                        names[0],
                        b1.subformRow
                      );
                    } else {
                      widgetElement = _this.getCurrentFieldElement(
                        a1,
                        b1.subformRow
                      );
                    }

                    if (widgetElement) {
                      _this.dataTable.renderErrorTip(widgetElement, b1.msg);
                    }
                  });
                  _this.dataTable.renderRowErrorTip(
                    _this.fieldData._id,
                    React.language("error")
                  );
                  clearInterval(delay);
                  delay = null;
                  console.log("this.rowRely.checkRelyAsyncState false");
                }
                return;
              }
            }, 1000);
          }
        };
        dem();
      }
    } else {
      _this.time = setTimeout(() => {
        _this.time = null;
        _this.ddm();
      }, _this.updateDelay);
    }
  };

  _getLinkValueMap = (t, e) => {
    let a = {};
    BsyUtils.forEach(e, function (t, e) {
      let i = get(e, "widget.widgetName");
      i && (a[i] = get(e, "widget.type"));
    });
    let n = {};
    BsyUtils.forEach(t, function (t, e) {
      switch (a[t]) {
        case "user":
        case "dept":
          n[t] = get(e, "_id", null) || get(e, "id", null);
          break;
        case "usergroup":
        case "deptgroup":
          n[t] = map(e, function (t) {
            return t._id || t.id;
          });
          break;
        case "datetime":
          let i = BsyUtils.parseDate(e);
          n[t] = i ? i.getTime() : null;
          break;
        default:
          n[t] = e;
      }
    });
    return n;
  };

  getViewVisibleMap = () => {
    this.rowRely.getViewVisibleMap();
    this.showRules = this.rowRely.showRules;
    this.subVisbleMaps = this.rowRely.subVisbleMaps;
    this.subColumnVisibleMaps = this.rowRely.subColumnVisibleMaps;
  };
}
